import { IPropertyInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { ITypeInfoMetadata } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/EntityBaseProperties";
import { ISoftDeletableEntityProperties, SoftDeletableEntityProperties } from "@seriously-rad/seriouslyrad-framework-core/Server/Schema/Entities/BaseTypes/SoftDeletableEntityProperties";

export interface ICaseMilestoneProperties extends IEntityBaseProperties, ISoftDeletableEntityProperties
{

    // #region Basic Properties

    step: IPropertyInfoMetadata;
    description: IPropertyInfoMetadata;
    helpText: IPropertyInfoMetadata;
    tracks: IPropertyInfoMetadata;

    // #endregion

    // #region Navigation Collection Properties

    caseMilestoneMappings: IPropertyInfoMetadata;

    // #endregion

}

export const CaseMilestone: ITypeInfoMetadata<ICaseMilestoneProperties> = {
    attributes: [
        {
            id: "{F305B36D-0A43-4053-BEFE-B5B8535DF2E8}",
            $type: "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework"
        },
        {
            name: "CaseMilestone",
            nameFriendly: "Case Milestone",
            namePlural: "CaseMilestones",
            namePluralFriendly: "Case Milestones",
            $type: "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework"
        }
    ],
    classHierarchy: [
        "GlobalMediation.Data.Entities.CaseMilestone, GlobalMediation.Data.Entities",
        "SeriouslyRAD.Framework.Data.EntityBase, SeriouslyRAD.Framework.Data.Entities",
        "System.Object, System.Private.CoreLib"
    ],
    hasEnumFlags: false,
    name: "CaseMilestone",
    properties: {
        ...EntityBaseProperties,
        ...SoftDeletableEntityProperties,
        step: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Step"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseMilestone+StepMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 0
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Step",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        description: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Description"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseMilestone+DescriptionMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 1
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareStringLengthAttribute, SeriouslyRAD.Framework",
                    maximumLength: 128,
                    minimumLength: 0,
                    requiresValidationContext: false
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Description",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        helpText: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Help Text"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 2
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "HelpText",
            propertyTypeId: "System.String, System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        tracks: {
            attributes: [
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                    displayName: "Tracks"
                },
                {
                    evaluator: {
                        $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                    },
                    $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[GlobalMediation.Data.Entities.CaseMilestone+TracksMandatoryEvaluatorAttributeType, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework"
                },
                {
                    $type: "SeriouslyRAD.Framework.ClientAwareOrderAttribute, SeriouslyRAD.Framework",
                    order: 3
                },
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "Tracks",
            propertyTypeId: "System.Nullable`1[[System.Int32, System.Private.CoreLib]], System.Private.CoreLib",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        },
        caseMilestoneMappings: {
            attributes: [
                {
                    classHierarchyDepth: 0,
                    $type: "SeriouslyRAD.Framework.ClientAwarePropertyInfoAttribute, SeriouslyRAD.Framework"
                }
            ],
            name: "CaseMilestoneMappings",
            propertyTypeId: "SeriouslyRAD.Framework.Data.Interception.EntityBaseHashSet`1[[GlobalMediation.Data.Entities.CaseMilestoneMapping, GlobalMediation.Data.Entities]], SeriouslyRAD.Framework.Data.Entities",
            $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
        }
    },
    underlyingTypeId: "GlobalMediation.Data.Entities.CaseMilestone, GlobalMediation.Data.Entities",
    $type: "SeriouslyRAD.Framework.Reflection.TypeInfoMetadata, SeriouslyRAD.Framework"
};

